/**
 * transition / transition-group names defined in _vue-transitions.
 */
export default Object.freeze({
  slideLeftIcon: 'slide-left-icon',
  slideRightIcon: 'slide-right-icon',
  slideLeft: 'slide-left',
  slideRight: 'slide-right',
  fastFade: 'fast-fade',
  fade: 'fade',
  fadeUp: 'fade-up',
  listItem: 'list-item',
  slideFadeList: 'slide-fade-list',
  fadeCycleDown: 'fade-cycle-down',
  fadeCycleUp: 'fade-cycle-up',
})
